import FlooringEditForm from "./flooring-edit-form";
import FlooringFiltersForm from "./flooring-filters-form";
import FlooringVariationEditForm from "./flooring-variation-edit-form";
import FlooringVariationFiltersForm from "./flooring-variation-filters-form";
import FlooringVariationFormFields from "./fields";

const FlooringForms = {
  Edit: FlooringEditForm,
  Filter: FlooringFiltersForm,
  VariationEdit: FlooringVariationEditForm,
  VariationFilter: FlooringVariationFiltersForm,
  Fields: FlooringVariationFormFields,
};

export default FlooringForms;
